//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
import { globalConfig } from "../../config/config";
const axios = require('axios');



export default class ViewVCSCheckedoutObjects extends Component {

	
	constructor(props)
	{
		console.log(props);
		super(props);
	}
	state = {
    vcsCheckedoutObjects: []
  	};

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
      axios.get(`${globalConfig.apiDatahubUrl}/vcs-checkedout-objects/`, globalConfig.hardcoded_header).then(res => {
      const vcsCheckedoutObjects = res.data;
      console.log(vcsCheckedoutObjects);
      this.setState({ vcsCheckedoutObjects });
      console.log(res.data[0]);
		});
		
	}

	render(){

        return (

			<form>
		
				<div class="container-fluid">
      <div style={{display: "flex", justifyContent: "space-between"}}>
			  <h4>Checked Out Files</h4>
			  <Link to="/waves">
			  	<Button variant="contained">
			  		Go Back
			  	</Button>
			  </Link>
      </div>
      <hr />
      <div className="form-group row">
      	<table class="table table-bordered table-striped">
      	<thead>
      	<tr>
      	<th scope="col">#</th>
      	<th scope="col">Filename</th>
     	<th scope="col">Checkout Time</th>
     	<th scope="col">Checked By</th>
     	<th scope="col">Description</th>
     	<th scope="col">Action</th>
    	</tr>
  		</thead>
  		<tbody>

          {this.state.vcsCheckedoutObjects.map( ( {vcsCheckedoutObjectId, vcsObjectId, vcsCOObjectTimestamp, vcsCOObjectUserid, 
          							vcsCOObjectDescription} ) => {
  					  return <tr><
  					  	td>{vcsCheckedoutObjectId}</td>
  					  	<td>{vcsObjectId} </td>
  					  	<td> {vcsCOObjectTimestamp}</td>
  					  	<td> {vcsCOObjectUserid}</td>
  					  	<td> {vcsCOObjectDescription}</td>
						<td>
							<button class="btn btn-success">Edit</button>&nbsp; 
  					  		<button class="btn btn-danger">Delete</button>
  					  	</td>
  					  	</tr>
					}) 
				}
        </tbody>
        </table>
      </div>
      </div>
		
			
	</form>
);
}
}
